<template>
    <div>
        <BarChart
                v-if="loaded"
                :chartdata="chartdata"
                :options="options"/>

    </div>
</template>
<script>
    import BarChart from './chart-main.vue'

    export default {
        name: 'EstudiantexCarreras',
        components: {BarChart},
        props: {
            resultados: {
                type: Array
            }
        },
        data: () => ({
            chartdata: {
                labels: [],
                datasets: [
                    {
                        backgroundColor: [],
                        data: []
                    }
                ]
            },
            loaded: false,
            options: {
                plugins: {
                    datalabels: {
                       //rotation: -90,
                        color: 'black',
                        anchor: 'end',
                        align: 'top',
                        font: {
                            size: "15",
                            weight: 'bold'
                        }
                    }
                },
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        gridLines: {
//                                drawBorder: true,
                            lineWidth: 2,
                            color: '#8D8E8E',
                            drawBorder: false,
                            zeroLineWidth: 3,
                            zeroLineColor: '#555555'
                        },
                        ticks: {
                            fontStyle: 'bold',
                            fontSize: 13,
                            fontColor: '#808080',
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            display: true,
//                                drawBorder: true,
                            lineWidth: 2,
                            color: '#9D9D9C',
                            drawBorder: false,
                            zeroLineWidth: 3,
                            zeroLineColor: '#555555'
                        },
                        ticks: {
                            fontStyle: 'bold',
                            fontSize: 13,
                            fontColor: '#626366',
                            beginAtZero: true,
                            min: 0,
                            max: 14,
                            stepSize: 2
                        }
                    }],
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }),
        created() {
            this.options.scales.xAxes[0].gridLines.color = 'white';
        },
        mounted() {
            this.getEstudiantesxCarreras()
        },
        methods: {
            getEstudiantesxCarreras() {
                this.loaded = false
                this.$store.dispatch('getStudiantePorCarrera', localStorage.getItem('keys'))
                    .then((response) => {
                        console.log(response.data)
                        for (let i = 0; i < response.data.cantidad_por_carrera.length; i++) {
                            this.chartdata.labels.push(response.data.cantidad_por_carrera[i].nombre)
                            this.chartdata.datasets[0].data.push(response.data.cantidad_por_carrera[i].total)
                            this.chartdata.datasets[0].backgroundColor.push(response.data.cantidad_por_carrera[i].color)
                        }
                        this.loaded = true
                    })
                    .catch((error) => {
                        console.log(error.message)
                    })

            }
        },
    }
</script>